import {
  Grid,
  Typography,
  CardContent,
  Card,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  TextField,
  ReferenceField,
  TextInput,
  SelectInput,
  useRecordContext,
} from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import FormField from "../../../components/Common/FormField";

function InfoProjectTab() {
  const { t }: { t: any } = useTranslation();
  const project = useRecordContext();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box pb={2}>
          <Typography variant="h6">{t("Entity details")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Identity, account and settings of this entity")}
          </Typography>
        </Box>
        <AnimatedBlock>
          <Card>
            <CardContent
              sx={{
                p: 4,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormField label={t("ID")}>
                    <TextField source="id" sx={{ fontFamily: "monospace", fontSize: 13 }} />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Code")}>
                    <TextField source="codeProject" sx={{ fontFamily: "monospace", fontSize: 13 }} />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Name")}>
                    <TextInput
                      source="name"
                      label={t("Name")}
                      fullWidth
                    />
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Account")}>
                    <ReferenceField source="accountId" reference="accounts">
                      <TextField source="name" />
                    </ReferenceField>
                  </FormField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormField label={t("Type")}>
                    <SelectInput fullWidth source="typeProject" label={t("Type")} choices={[
                      { id: 'gasStation', name: 'Gas station' },
                      { id: 'cryptoPayment', name: 'Crypto payment' },
                      //{ id: 'cardPayment', name: 'Card Payment' },
                    ]}/>
                  </FormField>
                </Grid>
                {project?.typeProject !== "gasStation" && (
                  <>
                    <Grid item xs={12} md={6}>
                      <FormField label={t("Auto conversion")}>
                        <SelectInput fullWidth
                          source="autoConvert"
                          label={t("Auto conversion")}
                          choices={[
                            { id: true, name: "Enabled" },
                            { id: false, name: "Disabled" },
                          ]}
                          defaultValue="enabled"
                        />
                      </FormField>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormField label={t("Fees included")}>
                        <SelectInput fullWidth
                          source="feesIncluded"
                          label={t("Fees included")}
                          choices={[
                            { id: true, name: "Yes" },
                            { id: false, name: "No" },
                          ]}
                          defaultValue="true"
                        />
                      </FormField>
                    </Grid>
                  </>
                )}
                <Grid item xs={12} md={6}>
                  <FormField label={t("Status")}>
                    <SelectInput fullWidth source="status" label={t("Status")} choices={[
                      { id: 'active', name: 'Active' },
                      { id: 'inactive', name: 'Inactive' },
                    ]}/>
                  </FormField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AnimatedBlock>
      </Grid>
    </Grid>
  );
}

export default InfoProjectTab;
